
export interface VoicePreference extends Partial<SpeechSynthesisVoice>{
    engine: 'eleven' |'11' | 'default' | 'oai' | 'system' | 'minimax';
    volume?: number;
    pitch?:  number;
    rate?: number; // também é o speed na minimax
    emotion?: MinimaxSpeechEmotions;
}

export interface VoiceServiceSettings {
    primaryVoice?: VoicePreference;
    secondaryVoice?: VoicePreference;
    volume?: number;
    customVoices?: Array<VoicePreference>;
    availableVoices?: Array<VoicePreference>;
}

export enum MinimaxSpeechEmotions {
    AUTO = 'auto',
    NEUTRAL = 'neutral',
    HAPPY = 'happy',
    SAD = 'sad',
    ANGRY = 'angry',
    FEARFUL = 'fearful',
    DISGUSTED = 'disgusted',
    SURPRISED = 'surprised'
}
